"use client";
import Image from "next/image";
import React from "react";
import SectionTitle from "../Common/SectionTitle";

const checkIcon = (
	<svg width="16" height="13" viewBox="0 0 16 13" className="fill-current">
		<path d="M5.8535 12.6631C5.65824 12.8584 5.34166 12.8584 5.1464 12.6631L0.678505 8.1952C0.483242 7.99994 0.483242 7.68336 0.678505 7.4881L2.32921 5.83739C2.52467 5.64193 2.84166 5.64216 3.03684 5.83791L5.14622 7.95354C5.34147 8.14936 5.65859 8.14952 5.85403 7.95388L13.3797 0.420561C13.575 0.22513 13.8917 0.225051 14.087 0.420383L15.7381 2.07143C15.9333 2.26669 15.9333 2.58327 15.7381 2.77854L5.8535 12.6631Z" />
	</svg>
);

const AboutSectionOne = () => {
	const [selectedImage, setSelectedImage] = React.useState(
		"/images/hero/heart.png",
	);
	const [selectedButton, setSelectedButton] = React.useState(1);

	const handleClickButton1 = () => {
		setSelectedButton(1);
		setSelectedImage("/images/hero/heart.png");
		handleOpen();
	};

	const handleClickButton2 = () => {
		setSelectedButton(2);
		setSelectedImage("/images/hero/lungs.png");
		handleOpen();
	};

	const [showSecondText, setShowSecondText] = React.useState(false);

	React.useEffect(() => {
		const timeoutId = setTimeout(() => {
			setShowSecondText(true);
		}, 5000);

		return () => clearTimeout(timeoutId);
	}, []); //

	const toggleText = () => {
		setShowSecondText((prevShowSecondText) => !prevShowSecondText);
	};

	React.useEffect(() => {
		const intervalId = setInterval(toggleText, 3000);

		return () => clearInterval(intervalId);
	}, []);

	const [open, setOpen] = React.useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	const handleOpen = () => {
		setOpen(true);
	};

	const imageStyle: React.CSSProperties = {
		marginRight: "10px",
	};

	return (
		<section
			id="about"
			className="bg-liwhite2 pt-16 dark:bg-saintiantblue md:pt-20 lg:pt-2"
		>
			{" "}
			<div className="mx-auto max-w-2xl rounded-full bg-saintiantblue p-3 text-center shadow-md dark:bg-gray-800">
				<h2 className="text-3xl leading-tight text-white dark:text-white sm:text-3xl sm:leading-tight">
					<span className="block font-normal">In Spanda</span>
					<span className="block font-bold">Technology Meets Innovation</span>
					<span className="block font-normal">to Solve Real-life Problems</span>
				</h2>
			</div>
			<h2 className="mt-5 text-center text-2xl font-medium leading-tight text-black dark:text-white sm:text-2xl sm:leading-tight">
				To know how, lets understand the characterstics of body sounds
			</h2>
			<div className="mb-4"></div>
			<div className="mt-8 flex flex-wrap items-center justify-center gap-2">
				<button
					onClick={handleClickButton1}
					className={`hover:bg-primary-dark focus:shadow-outline-primary mb-4 rounded-md px-6 py-3 text-white focus:outline-none ${selectedButton === 1
							? "bg-saintiantblue"
							: "bg-saintiantblue opacity-50 hover:opacity-100"
						}`}
				>
					Heart
				</button>
				<button
					onClick={handleClickButton2}
					className={`hover:bg-primary-dark focus:shadow-outline-primary mb-4 rounded-md px-6 py-3 text-white focus:outline-none ${selectedButton === 2
							? "bg-saintiantblue"
							: "bg-saintiantblue opacity-50 hover:opacity-100"
						}`}
				>
					Lungs
				</button>
			</div>
			<div className="wow fadeInUp lg:ml-1/6 relative mx-auto lg:mr-0">
				{selectedImage && (
					<div className="flex items-center justify-center">
						<Image
							src={selectedImage}
							alt="Selected Image"
							width={3000}
							height={200}
							className="mx-auto w-full rounded-3xl drop-shadow-three dark:hidden dark:drop-shadow-none"
						/>
					</div>
				)}
			</div>
			<div>
				<h2 className="mt-10 text-center font-bold leading-tight text-black dark:text-white sm:text-3xl sm:leading-tight">
					NOW DIAGNOSE WITH CONFIDENCE
				</h2>
			</div>
			<br />
			<div className="flex flex-col-reverse items-center justify-center lg:flex-row">
				<div className="mb-6 w-full px-4 text-center lg:mb-0 lg:w-2/5">
					<SectionTitle
						title={
							<span style={{ fontSize: "1.5rem" }}>
								Dynamic Noise Filtering (DNF) & Cancellation along with Dual Band Amplification (DBA) to enhance the
								auscultation experience.
							</span>
						}
						paragraph={<></>}
						mb="4"
					/>
				</div>
				<div className="h-72 w-72 overflow-hidden md:h-96 md:w-96">
					<Image
						src="/images/blog/pcb.png"
						alt="Digital Stethoscope in India"
						width={400}
						height={400}
						className="h-full w-full rounded-3xl object-cover"
					/>
				</div>
			</div>
			{/* section 2 */}
			<div className="mt-5 flex flex-col items-center justify-center md:flex-row">
				<div className="mb-5 h-72 w-72 overflow-hidden rounded-3xl md:mb-0 md:ml-0 md:h-96 md:w-96 lg:ml-52">
					<Image
						src="/images/blog/hearing2.png"
						alt="Doctor using Spanda Digital Stethoscope for High Quality Cardiac Auscultation"
						width={400}
						height={400}
						className="h-full w-full rounded-3xl object-cover"
					/>
				</div>
				<div className="w-full text-center md:mt-5 md:px-5 lg:w-2/5">
					<SectionTitle
						title={
							<span style={{ fontSize: "1.5rem" }}>
								Hearing Acuity Personalization(HAP) wherein frequency specific
								amplitudes are adjusted to your hearing ability.
							</span>
						}
						paragraph={<></>}
						mb="4"
					/>
				</div>
			</div>
			{/* section 3 */}
			<div className="mt-5 flex flex-col-reverse items-center justify-center lg:flex-row">
				<div className="mb-6 w-full px-4 text-center lg:mb-0 lg:w-2/5">
					<SectionTitle
						title={
							<span style={{ fontSize: "1.5rem" }}>
								Point of Interest(PoI) facilitates a precise amplification of
								specific sound of interest for accurate assessment.
							</span>
						}
						paragraph={<></>}
						mb="4"
					/>
				</div>
				<div className="h-72 w-72 overflow-hidden md:h-96 md:w-96">
					<Image
						src="/images/blog/magni.png"
						alt="Digital Stethoscope in India"
						width={400}
						height={400}
						className="h-full w-full rounded-3xl object-cover"
					/>
				</div>
			</div>
			<div className="relative z-10 mt-5 overflow-hidden rounded-md bg-primary bg-opacity-10 p-8 md:p-9 lg:p-8 xl:p-9">
				<p className="text-center text-xl font-medium italic text-body-color">
					A Spanda in the hands of a skilled practitioner is more than just a
					tool, it’s a lifeline.
				</p>
			</div>
		</section>
	);
};

export default AboutSectionOne;
